export default class Player {
    constructor(game, x, y) {
        this.game = game
        this.image = document.getElementById('digitVanoce')
        this.x = x
        this.y = y
        this.width = 136
        this.height = 139
        this.rotation = 0
        this.rotationDecrement = 0.0006
        this.minRotationSpeed = 0.2
        this.maxRotationSpeed = 0.7
        this.rotationFrequency = this.minRotationSpeed
        this.gravity = 0.0015
        this.jumpHeight = 0.6
        this.velocityY = 0
        this.scale = 0.4
        this.colisionRadius = this.width * this.scale / 2
        this.collisionOriginX = this.x + this.width * this.scale / 2
        this.collisionOriginY = (this.y + this.height * this.scale) - this.colisionRadius
        this.extraLifes = 0
        this.immortality = false
        this.immortalityTime = 175
        this.immortalitySpeed = 0.2
        this.fading = true
        this.opacity = 1
    }
    update(input, deltaTime) {
        if(input.keys.includes('jump') && input.eligibleForUpdate) {
            this.velocityY = 0
            this.velocityY -= this.jumpHeight
            this.rotationFrequency = this.maxRotationSpeed
            input.eligibleForUpdate = false
        }

        if(this.rotationFrequency <= this.minRotationSpeed) {
            this.rotationFrequency = this.minRotationSpeed
        } else {
            this.rotationFrequency -= this.rotationDecrement * deltaTime
        }
        if(this.immortality) {
            this.immortalityTime -= this.immortalitySpeed * deltaTime
            if(this.immortalityTime < 0) {
                this.immortalityTime = 175
                this.immortality = false
                this.opacity = 1
            }
            if (this.fading) {
                this.opacity -= 0.0125 * deltaTime
                if (this.opacity <= 0) {
                    this.fading = false
                }
            } else {
                this.opacity += 0.0125 * deltaTime
                if (this.opacity >= 1) {
                    this.fading = true
                }
            }
        } else {
            if(this.opacity < 1) {
                this.opacity += 0.0125 * deltaTime
                if(this.opacity > 1) {
                    this.opacity = 1
                }
            }
        }

        this.velocityY += this.gravity * deltaTime
        this.y += this.velocityY * deltaTime
        this.rotation += this.rotationFrequency * deltaTime
        this.updateCollisionCircle()
        this.checkCollisionFloor()
        this.checkCollisionSealing()
    }
    draw(context) {
        context.globalAlpha = this.opacity
        context.translate(this.x + this.width * this.scale / 2, this.y + this.height * this.scale / 2)
        context.rotate(this.rotation * Math.PI / 180)
        context.translate(-(this.x + this.width * this.scale / 2), -(this.y + this.height * this.scale / 2))
        context.drawImage(this.image, 0, 0, this.width, this.height, this.x, this.y, this.width * this.scale, this.height * this.scale)
        context.setTransform(1, 0, 0, 1, 0, 0)
        //context.strokeStyle = "#000000"
        //context.lineWidth = 3
        //context.beginPath();
        //context.arc(this.collisionOriginX, this.collisionOriginY, this.colisionRadius, 0, 2 * Math.PI);
        //context.stroke();
    }
    updateCollisionCircle() {
        this.colisionRadius = this.width * this.scale / 2
        this.collisionOriginX = this.x + this.width * this.scale / 2
        this.collisionOriginY = (this.y + this.height * this.scale) - this.colisionRadius
    }
    checkCollisionFloor() {
        if(this.height * this.scale + this.y >= this.game.height) {
            return true
        }
    }
    checkCollisionSealing() {
        if(this.y <= 0) {
            return true
        }
    }
    checkCollisionWithEnemy() {
        for(var i in this.game.enemies) {
            const enemy = this.game.enemies[i]
            const a = enemy.collisionOriginX - this.collisionOriginX
            const b = enemy.collisionOriginY - this.collisionOriginY
            const distanceOdEnemy = Math.sqrt(a * a + b * b)
            if(distanceOdEnemy <= enemy.colisionRadius + this.colisionRadius) {
                this.game.narazDoNepritele = true
                this.game.maxGameSpeed = 0
            }
        }
    }
    changeImage(image) {
        this.image = document.getElementById(image)
    }
}
